import { BaseApi } from '@/api/BaseApi'
import {
  IScheduleGetDailyScheduleApiResponse,
  IScheduleGetDailyScheduleApiDetail,
  IScheduleGetMonthlyScheduleApiResponse,
  IScheduleGetMonthlyScheduleApiDetail,
  GetDefaultScheduleApiRequest,
  GetDefaultScheduleApiResponse,
  GetDefaultScheduleApiDetail,
} from '@/types/common/schedule'
import { AxiosInstance } from 'axios'

const PATH = {
  GET_DAILY_SCHEDULE: '/api/common/photographers/{photographerId}/schedules/{year}/{month}/{day}',
  GET_MONTHLY_SCHEDULE: '/api/common/photographers/{photographerId}/schedules/{year}/{month}',
  GET_DEFAULT_SCHEDULE: '/api/common/photographers/:photographerUserId/schedules/default-info',
} as const

export class ScheduleApi {
  baseApi: BaseApi
  constructor(axios: AxiosInstance) {
    this.baseApi = new BaseApi(axios)
  }

  /**
   * 対象のフォトグラファーの指定日のスケジュールを取得
   */
  public async getDailySchedule(
    photographerId: number,
    year: number,
    month: number,
    day: number
  ): Promise<IScheduleGetDailyScheduleApiDetail> {
    const path = this.baseApi.makeUrl(
      PATH.GET_DAILY_SCHEDULE,
      new Map([
        ['photographerId', photographerId],
        ['year', year],
        ['month', month],
        ['day', day],
      ])
    )
    const { data } = await this.baseApi.get<IScheduleGetDailyScheduleApiResponse>(path)

    const schedule: IScheduleGetDailyScheduleApiDetail['schedule'] = {}
    for (const [key, value] of Object.entries(data.schedule)) {
      schedule[key] = { acceptStatus: value.accept_status }
      if (value.schedule_id) {
        schedule[key]['scheduleId'] = value.schedule_id
      }
    }

    return {
      schedule: schedule,
      prev: data.prev,
      next: data.next,
      holidayFlag: data.holiday_flag,
    }
  }

  /**
   * 対象のフォトグラファーの指定月のスケジュールを取得
   */
  public async getMonthlySchedule(
    photographerId: number,
    year: number,
    month: number
  ): Promise<IScheduleGetMonthlyScheduleApiDetail> {
    const path = this.baseApi.makeUrl(
      PATH.GET_MONTHLY_SCHEDULE,
      new Map([
        ['photographerId', photographerId],
        ['year', year],
        ['month', month],
      ])
    )
    const { data } = await this.baseApi.get<IScheduleGetMonthlyScheduleApiResponse>(path)

    const schedule: IScheduleGetMonthlyScheduleApiDetail['schedule'] = {}
    for (const [key, value] of Object.entries(data.schedule)) {
      schedule[key] = {
        freeFlag: value.free_flag,
        holidayFlag: value.holiday_flag,
      }
    }

    return {
      schedule: schedule,
    }
  }

  /**
   * スケジュール初期情報取得API
   *
   * @param photographerUserId フォトグラファーID
   * @param date yyyy-mm-dd
   */
  public async getDefaultSchedule(photographerUserId: number, date?: string): Promise<GetDefaultScheduleApiDetail> {
    // 指定した日付のスケジュールを取得
    let request: GetDefaultScheduleApiRequest = {}
    if (date !== undefined) {
      request = { date: date }
    }

    const path = PATH.GET_DEFAULT_SCHEDULE.replace(':photographerUserId', String(photographerUserId))

    const { data } = await this.baseApi.get<GetDefaultScheduleApiResponse>(path, {}, { params: request })

    return {
      photographerUserId: data.user_id,
      photographerSlug: data.photographer_slug,
      price: data.price,
      holidayPrice: data.holiday_price,
      scheduleOpenPeriod: data.schedule_open_period,
      loadDate: data.load_date,
      loadScheduleType: data.load_schedule_type,
      scheduleMaxNum: data.schedule_max_num,
    }
  }
}
